import React, { useState, useMemo } from 'react';
import styled from 'styled-components/macro';

import { ReactComponent as tiktok } from 'icons/platforms/tiktok.svg';
import { ReactComponent as wesee } from 'icons/platforms/wesee.svg';
import { ReactComponent as youtubeshorts } from 'icons/platforms/youtubeshorts.svg';

const StyledIcon = styled.svg`
  width: 18px;
  height: 18px;
`;

const StyledImg = styled.img<{ $visibility?: boolean }>`
  display: ${(props): string => (props.$visibility ? 'block' : 'none')};
  width: 18px;
  height: 18px;
  object-fit: cover;
`;

interface IMediaIconProps {
  icon: string;
  platformName: string;
}

const MediaIcon: React.FC<IMediaIconProps> = (props) => {
  const [loaded, setLoaded] = useState(false);
  const { platformName, icon } = props;

  const iconComponent = useMemo(() => {
    switch (platformName) {
      case 'tiktok':
      case 'douyin':
        return tiktok;
      case 'wesee':
        return wesee;
      case 'youtubeShorts':
        return youtubeshorts;
    }
  }, [platformName]);

  const onComplete = (): void => setLoaded(true);
  const onError = (): void => setLoaded(false);

  return icon ? (
    <>
      <StyledImg
        src={icon}
        alt={platformName}
        onLoad={onComplete}
        $visibility={loaded}
        onError={onError}
      />
      {!loaded && <StyledIcon as={iconComponent} />}
    </>
  ) : (
    <StyledIcon as={iconComponent} />
  );
};

export default MediaIcon;
